import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useRecoilState } from 'recoil';
import Progress from '@/features/uploadMedia/Progress';
import { TaskStatus, TaskType } from '@/services/uploaderService';
import taskStateFamily from '@/stores/taskStateFamilyStore';
import { useUser } from '@/services/userService';
import { useAddPhotosButton } from './useAddPhotosButton';

type AddPhotosLabelProps = {
  className?: string;
};

export function AddPhotosButton({ className }: AddPhotosLabelProps) {
  const {
    handleAddPhotos,
    text,
    onClickAddPhotos,
    allowMultipleMediaSelection,
  } = useAddPhotosButton();
  const [task] = useRecoilState(taskStateFamily('result'));
  const isOverlayVisible = task.status !== TaskStatus.Pristine;
  const { data: user } = useUser();

  return (
    <div
      className={`h-full relative ${
        isOverlayVisible
          ? 'overflow-hidden'
          : 'overflow-auto lg:tall:overflow-hidden'
      }`}
    >
      <label htmlFor="add-photos" className={className}>
        {text}
      </label>
      <input
        multiple={allowMultipleMediaSelection}
        disabled={user?.monetization?.hasIncompleteSubscription}
        type="file"
        accept={'image/*,.heic,.tga'}
        id="add-photos"
        className="invisible block w-0 h-0 overflow-hidden"
        onClick={(e) => onClickAddPhotos(e)}
        onChange={(e) => handleAddPhotos(e.target.files)}
      />

      <AnimatePresence>
        {isOverlayVisible && (
          <motion.div
            key="progress"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-60"
          >
            <Progress mediaType={TaskType.Image} isBulkUpload forId="result" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
